import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { useStoreContext } from '../context/store';
import SmileSelect from './SmileSelect';
import { useI18n } from '../utils/i18n';

export const StoreSelector = ({ question, value, onChange }) => {
  const { context, dispatch, instance } = useStoreContext();
  const [stores, setStores] = useState(undefined);
  const isRequired = get(question, 'metadata.settings.required', true);
  const { data } = context;
  const t = useI18n();

  useEffect(() => {
    if(!get(data,'hash') || get(data, 'hash', '') === 'playground') return;
    (async ()=>{
        const newStores = await instance.sdk.getStores();
        setStores([...newStores.map(store=>{
            return{value:store.key,caption:store.nombre_sucursal, key:store.key}
        })]);
    })();

  }, [instance, data]);

  function setStore(key){
    const currentStore = stores.find((store)=> store.key === key);
    onChange({...value,store_key:key});
    dispatch({
        type: 'data.update',
        payload: {
          store:{...currentStore}
        },
    });
  }
  return (
    <SmileSelect
      autocomplete={true}
      style={{margin:'10px'}}
      dataTestId={`formstores`}
      value={get(data,'store.key')}
      label={t('stores')}
      required={isRequired}
      onChange={(ev) => setStore(ev.target.value)}
      options={stores || []}
      showError={get(value,'dirty') && isRequired && !get(data,'store.key')}
    />
  );
};
